/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Projects_Bulk_Archive_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to archive {count} project(s)" |
*
* @param {Projects_Bulk_Archive_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_bulk_archive_error = /** @type {((inputs: Projects_Bulk_Archive_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Bulk_Archive_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Projekt(e) konnten nicht archiviert werden`)
	return /** @type {LocalizedString} */ (`Failed to archive ${i?.count} project(s)`)
});